import { loginUrl, signupUrl, refreshTokenUrl, logoutUrl } from "./constants";
import base from "../middlewares/interceptors";
import {
  LoginRequest,
  LoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  LogoutResponse,
} from "../types/auth";

export const login = async (
  payload: LoginRequest,
): Promise<LoginResponse | undefined> => {
  try {
    const response = await base.post(loginUrl, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const signup = async (payload: any) => {
  try {
    const response = await base.post(signupUrl, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const refreshToken = async (
  payload: RefreshTokenRequest,
): Promise<RefreshTokenResponse | undefined> => {
  try {
    const response = await base.post(refreshTokenUrl, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const logout = async (
  sessionId: string,
  userId: number,
): Promise<LogoutResponse | undefined> => {
  try {
    const response = await base.post(
      `${logoutUrl}?session_id=${sessionId}&user_id=${userId}`,
      {},
    );
    return response?.data;
  } catch (error) {
    console.error("Logout API error:", error);
  }
};
